var w = (o) => {
  throw TypeError(o);
};
var E = (o, t, n) => t.has(o) || w("Cannot " + n);
var f = (o, t, n) => t.has(o) ? w("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(o) : t.set(o, n);
var a = (o, t, n) => (E(o, t, "access private method"), n);
var p, D;
class A {
  constructor({
    mark: t,
    view: n,
    inline: s,
    options: u
  }) {
    f(this, p);
    this.shouldIgnoreMutation = (h) => !this.dom || !this.contentDOM ? !0 : h.type === "selection" ? !1 : this.contentDOM === h.target && h.type === "attributes" ? !0 : !this.contentDOM.contains(h.target), this.ignoreMutation = (h) => {
      if (!this.dom || !this.contentDOM)
        return !0;
      let r;
      const e = this.options.ignoreMutation;
      return e && (r = e(h)), typeof r != "boolean" && (r = this.shouldIgnoreMutation(h)), r;
    }, this.destroy = () => {
      var h, r;
      (r = (h = this.options).destroy) == null || r.call(h), this.dom.remove(), this.contentDOM.remove();
    }, this.mark = t, this.view = n, this.inline = s, this.options = u, this.dom = this.createDOM(u.as), this.contentDOM = this.createContentDOM(u.contentAs), this.dom.setAttribute("data-mark-view-root", "true"), this.contentDOM.setAttribute("data-mark-view-content", "true"), this.contentDOM.style.whiteSpace = "inherit";
  }
  createDOM(t) {
    return a(this, p, D).call(this, t);
  }
  createContentDOM(t) {
    return a(this, p, D).call(this, t);
  }
  get component() {
    return this.options.component;
  }
}
p = new WeakSet(), D = function(t) {
  const { inline: n, mark: s } = this;
  return t == null ? document.createElement(n ? "span" : "div") : t instanceof HTMLElement ? t : t instanceof Function ? t(s) : document.createElement(t);
};
var m, g;
class C {
  constructor({ node: t, view: n, getPos: s, decorations: u, innerDecorations: h, options: r }) {
    f(this, m);
    this.selected = !1, this.selectNode = () => {
      var e, i;
      this.selected = !0, (i = (e = this.options).selectNode) == null || i.call(e);
    }, this.deselectNode = () => {
      var e, i;
      this.selected = !1, (i = (e = this.options).deselectNode) == null || i.call(e);
    }, this.shouldUpdate = (e) => !(e.type !== this.node.type || e.sameMarkup(this.node) && e.content.eq(this.node.content)), this.update = (e, i, c) => {
      var O, v;
      const d = this.options.update;
      let l;
      return d && (l = d(e, i, c)), typeof l != "boolean" && (l = this.shouldUpdate(e)), this.node = e, this.decorations = i, this.innerDecorations = c, l && ((v = (O = this.options).onUpdate) == null || v.call(O)), l;
    }, this.shouldIgnoreMutation = (e) => !this.dom || !this.contentDOM || this.node.isLeaf || this.node.isAtom ? !0 : e.type === "selection" ? !1 : this.contentDOM === e.target && e.type === "attributes" ? !0 : !this.contentDOM.contains(e.target), this.ignoreMutation = (e) => {
      if (!this.dom || !this.contentDOM)
        return !0;
      let i;
      const c = this.options.ignoreMutation;
      return c && (i = c(e)), typeof i != "boolean" && (i = this.shouldIgnoreMutation(e)), i;
    }, this.destroy = () => {
      var e, i, c;
      (i = (e = this.options).destroy) == null || i.call(e), this.dom.remove(), (c = this.contentDOM) == null || c.remove();
    }, this.setAttrs = (e) => {
      const { dispatch: i, state: c } = this.view, d = this.getPos();
      if (typeof d == "number")
        return i(
          c.tr.setNodeMarkup(d, void 0, {
            ...this.node.attrs,
            ...e
          })
        );
    }, this.node = t, this.view = n, this.getPos = s, this.decorations = u, this.innerDecorations = h, this.options = r, this.dom = this.createDOM(r.as), this.contentDOM = t.isLeaf ? null : this.createContentDOM(r.contentAs), this.dom.setAttribute("data-node-view-root", "true"), this.contentDOM && (this.contentDOM.setAttribute("data-node-view-content", "true"), this.contentDOM.style.whiteSpace = "inherit"), this.setSelection = r.setSelection, this.stopEvent = r.stopEvent;
  }
  createDOM(t) {
    return a(this, m, g).call(this, t);
  }
  createContentDOM(t) {
    return a(this, m, g).call(this, t);
  }
  get component() {
    return this.options.component;
  }
}
m = new WeakSet(), g = function(t) {
  const { node: n } = this;
  return t == null ? document.createElement(n.isInline ? "span" : "div") : t instanceof HTMLElement ? t : t instanceof Function ? t(n) : document.createElement(t);
};
class k {
  constructor(t) {
    this.view = t.view, this.options = t.options;
  }
  get component() {
    return this.options.component;
  }
  get root() {
    var n, s;
    let t = (s = (n = this.options).root) == null ? void 0 : s.call(n, this.view.dom);
    return t || (t = this.view.dom.parentElement ?? document.body), t;
  }
  update(t, n) {
    var s, u;
    this.view = t, this.prevState = n, (u = (s = this.options).update) == null || u.call(s, t, n);
  }
  destroy() {
    var t, n;
    (n = (t = this.options).destroy) == null || n.call(t);
  }
}
var M, y;
class I {
  constructor({ pos: t, spec: n, options: s }) {
    f(this, M);
    this.pos = t, this.options = s, this.spec = n, this.dom = a(this, M, y).call(this, s.as), this.dom.setAttribute("data-widget-view-root", "true");
  }
  bind(t, n) {
    this.view = t, this.getPos = n;
  }
  get component() {
    return this.options.component;
  }
}
M = new WeakSet(), y = function(t) {
  return t instanceof HTMLElement ? t : document.createElement(t);
};
export {
  A as CoreMarkView,
  C as CoreNodeView,
  k as CorePluginView,
  I as CoreWidgetView
};
//# sourceMappingURL=index.es.js.map
